import styles from './styles.module.scss'

import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';

import { Button } from 'antd';
import { ArrowDownOutlined } from '@ant-design/icons';

import { getNavUrl } from '@/utils/navigation';

export const PageAbout = () => {
  const history = useHistory()

  const moveToSignUp = (e: React.MouseEvent) => {
    e.preventDefault();
    history.push(getNavUrl('/sign_up'))
  }

  return (
    <>
      <Helmet>
        <title>고객을 끌어오는 구글 애널리틱스4</title>
      </Helmet>
      <div className={styles.header}>
        <h2>고객을 끌어오는 구글 애널리틱스4</h2>
      </div>
      <div className={styles.description}>
        <p>고객을 끌어오는 구글 애널리틱스4를 시작합니다.</p>
      </div>
      <div className={styles.content}>
        <hr className={styles.divider} />
        <p><ArrowDownOutlined /> 더 아래로 스크롤해주세요</p>
        <hr className={styles.divider} />
        <p><ArrowDownOutlined /> 더 아래로 스크롤해주세요</p>
        <hr className={styles.divider} />
        <p><ArrowDownOutlined /> 더 아래로 스크롤해주세요</p>
        <hr className={styles.divider} />
        <Button onClick={(e) => moveToSignUp(e) } type="primary" size="large">가입하기</Button>
        <hr className={styles.divider} />
      </div>
    </>
  )
}
